import React from "react";
import {
  Box,
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from "@chakra-ui/react";
import { COPILOT_UPGRADE_STRIPE_PLANS } from "../utils/copilotUpgrade";

export default function CopilotUpgradeButtons({
  size = "sm",
  colorScheme = "orange",
  ...wrapperProps
}) {
  return (
    <Box {...wrapperProps}>
      <Menu>
        <MenuButton
          as={Button}
          colorScheme={colorScheme}
          size={size}
          fontWeight="semibold"
        >
          Upgrade
        </MenuButton>
        <MenuList>
          {COPILOT_UPGRADE_STRIPE_PLANS.map((plan) => (
            <MenuItem
              key={plan.label}
              as="a"
              href={plan.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {plan.label}
            </MenuItem>
          ))}
        </MenuList>
      </Menu>
    </Box>
  );
}
